<template>
  <div class="A4">
    <ReportHeader />
    <table class="table table-bordered table-sm table-striped no-bor">
      <thead>
        <tr style="font-size: 13px">
          <th class="text-cener">
            <!-- ល.រ<br/> -->
            Date
          </th>
          <th class="text-cener" style="width: 125px">
            <!-- លេខវិក្កយបត្រ<br/> -->
            Invoice No.
          </th>
          <th class="text-cener">
            <!-- ឈ្មោះអតិថិជន<br/> -->
            Name
          </th>
          <th class="text-cener">
            <!-- ឈ្មោះអតិថិជន<br/> -->
            Code
          </th>
          <th class="text-cener">
            <!-- បរិយាយទំនិញ ឬសេវាកម្ម<br/> -->
            ItemName
          </th>
          <th class="text-cener" style="width: 50px">
            <!-- បរិមាណ<br/> -->
            Qty
          </th>
          <th class="text-cener">
            <!-- តម្លៃ<br/> -->
            Price
          </th>
          <th class="text-cener">Amount</th>
          <th class="text-cener">VAT / Sales Tax</th>
          <th class="text-cener">
            <!-- អត្រាប្តូប្រាក់<br/> -->
            Exchange Rate
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(ret, index) in records" :key="index">
          <td class="text-center">{{ $format(ret.Date, "DD/MM/YYYY") }}</td>
          <td>{{ ret.Num }}</td>
          <td>{{ ret.CustomerName }}</td>
          <!-- <td>{{ ret.VatTin }}-{{ ret.TinHead }}</td> -->
          <td>{{ ret.ItemCode }}</td>
          <td>{{ ret.ItemName }}</td>
          <td class="text-center">{{ ret.Quantity }}</td>
          <td class="text-right">{{ $number(ret.Price, "0.00000") }}</td>
          <td class="text-right">
            {{ $money(ret.Quantity * ret.Price + ret.TaxLine) }}
          </td>
          <td class="text-center">{{ ret.TaxLine == 0 ? "No" : "Yes" }}</td>
          <td class="text-right">{{ $number(ret.ExchangeRate) }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
import ReportHeader from "../../../Components/ReportHeader";
export default {
  components: { ReportHeader },
  data() {
    return {
      query: {
        CustomerId: "",
        FromDate: this.$startOfMonth(),
        ToDate: this.$endOfMonth(),
        FilterType: 3
      },
      records: [],
      summary: {
        Untax: 0,
        TaxAmount: 0,
        IncludeTax: 0,
        TotalAmount: 0,
        TotalAmtRiel: 0,
      },
    };
  },
  created() {
    let qr = this.$route.query;
    this.query.FromDate = qr.fd;
    this.query.ToDate = qr.td;
    this.query.CustomerId = qr.cs;
    this.query.CompanyId = this.$store.state.company.Id;
    this.query.FilterType = qr.ft;
    this.toList();
  },
  methods: {
    toList() {
      var loading = this.$loading.show();
      this.$api()
        .post("invoice/report-invoice-detail", this.query)
        .then((res) => {
          if (this.$isValid(res)) {
            this.records = res.data.Json.Invoices;
            this.calculate();
          }
        })
        .finally(() => {
          loading.hide();
        });
    },
    calculate() {
      let untax = 0;
      let tax = 0;
      let inctax = 0;
      let total = 0;
      let totalRiel = 0;
      this.records.forEach((el) => {
        untax += el.GrandTotal;
        tax += el.TaxVat;
        inctax += el.IncludeTaxAmount;
        total += el.TotalAmount;
        totalRiel += el.TotalAmount * el.ExchangeRate;
      });
      this.summary.Untax = untax;
      this.summary.TaxAmount = tax;
      this.summary.IncludeTax = inctax;
      this.summary.TotalAmount = total;
      this.summary.TotalAmtRiel = totalRiel;
    },
  },
};
</script>
